import { Button } from "@portal/BaseComponents/Button/AntButton";
import { ToolTip } from "@portal/BaseComponents/ToolTip/AntTooltip";
import useOpen from "@portal/hooks/useOpen";
import { Icon } from "@portal/lib/icons/icons";
import { Invoice } from "@portal/types/entities/invoice";
import { ActivitiesActionButtonProps } from "../type";
import DisputeModal from "./DisputeForm/Modal/DisputeModal";

const t = {
  title: "Raise Dispute",
};

interface RaiseDisputeProps extends ActivitiesActionButtonProps {
  defaultInvoices?: Invoice[];
}

function RaiseDispute(props: RaiseDisputeProps) {
  const {
    title = t.title,
    buttonProps,
    iconOnly,
    showToolTip,
    onOpenChange,
    defaultInvoices,
    open: defaultOpen,
  } = props;

  const { open, onClose, toggleOpen } = useOpen({
    open: defaultOpen ? defaultOpen : false,
  });

  function handleClose() {
    onClose();
    props.onclose?.();
  }
  const RDIcon = <Icon icon={["far", "comment-times"]} />;
  const Modal = (
    <DisputeModal
      open={open}
      onClose={handleClose}
      onOpenChange={onOpenChange}
      defaultInvoiceValue={defaultInvoices}
    />
  );

  return (
    <>
      <ToolTip
        title={t.title}
        open={showToolTip ? undefined : false}
        destroyTooltipOnHide
      >
        <Button icon={RDIcon} {...buttonProps} onClick={toggleOpen}>
          {iconOnly ? null : title}
        </Button>
      </ToolTip>
      {open && Modal}
    </>
  );
}

export { RaiseDispute };
